/**
 * Projects: reference holders that group collections, boards, documents, connections… (Graph & Projects, 13.09.2026).
 * HOST-RENDERED (calendar precedent): the page is wired in App.js
 * (`activeTab === 'projects.panel'`) as a full-bleed view; entry.js is a no-op
 * kept for the registration contract. Records: extension_documents
 * (extension_id 'projects'), see src/graph/projectsStore.js.
 */
export const projectsManifest = {
  schemaVersion: 1,
  id: 'com.apiboo.projects',
  name: 'Projects',
  version: '0.1.0',
  publisher: 'apiboo',
  entry: 'dist/main.js',
  icon: 'folder-kanban',
  engines: { apibooSdk: '^1.0.0' },
  hostRendered: true,
  permissions: [],
  contributes: {
    activityBar: [{ id: 'projects.activity', title: 'Projects', icon: 'folder-kanban', order: { after: 'vault.activity' } }],
    panels: [{ id: 'projects.panel', activityBarId: 'projects.activity', title: 'Projects' }],
    settings: [],
  },
};
